<template>
  <div class="content">
    <div v-show="serviceList.total === 0">
      <div class="kongImg">
        <img
          alt=""
          :src="
            $common.getResourceUrl('pcweb/pcKongStatus/img_dingdankong.png')
          "
        />
        <p>查询不到服务呦</p>
      </div>
    </div>
    <div v-show="serviceList.total !== 0" class="servicebox">
      <div
        v-for="(item, index) in serviceList.data"
        :key="index"
        class="serviceMain"
        :style="{
          backgroundImage: item.background
            ? 'url(' + item.background + ')'
            : 'none',
          backgroundColor: item.back_color ? item.back_color : '#fb6c55',
        }"
      >
        <span class="status">{{ item.status_text }}</span>
        <p class="title">{{ item.name }}</p>
        <p class="validity">{{ item.start_date + ' - ' + item.end_date }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { getServiceList } from '@/network/request'
export default {
  data() {
    return {
      pageInfo: {
        page: 1, // 页码
        limit: 8, // 每页显示多少条数据
      },
      serviceList: {}, // 服务列表数据
      total: null, // 数据总条数
    }
  },
  created() {
    this.getServiceList()
  },
  methods: {
    // 获取服务列表
    async getServiceList() {
      const date = this.pageInfo
      const res = await getServiceList(date)
      // console.log(res)
      this.serviceList = res.data.result
      // console.log(this.serviceList)
      this.total = this.serviceList.total
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 20px;
}
.kongImg {
  text-align: center;
  padding-top: 80px;

  img {
    margin: auto;
    width: 500px;
  }
  p {
    text-align: center;
    margin-top: 20px;
    color: #bbb;
    font-size: 16px;
  }
}
.servicebox {
  overflow: hidden;
}
.serviceMain {
  float: left;
  width: 46%;
  position: relative;
  border-radius: 4px;
  padding: 80px 25px 25px 25px;
  margin-bottom: 20px;
  background-size: 100% auto;
  background-position: center;
  &:nth-child(2n) {
    margin-left: 2%;
  }

  .title {
    font-size: 20px;
    color: #fff;
    margin-bottom: 12px;
  }
  .validity {
    font-size: 14px;
    color: #fff;
  }
}

.status {
  position: absolute;
  box-sizing: border-box;
  right: 27px;
  top: 23px;
  font-size: 12px;
  color: #fff;
  border: solid 1px #ffffff;
  padding: 4px 8px;
}
</style>
